import React from "react";

const UploadLoader = ({ text = "Uploading file, please wait...", progress = null }) => {
  return (
    <div className="fixed inset-0 z-[9999] bg-black/50 backdrop-blur-[2px] flex items-center justify-center p-4">
      <div className="flex flex-col items-center gap-3 bg-white/95 px-8 py-6 rounded-xl shadow-2xl min-w-[280px] max-w-sm w-full">
        <div className="h-12 w-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
        <p className="text-sm font-semibold text-gray-800 text-center">
          {text}
        </p>
        {progress !== null && (
          <div className="w-full mt-2">
            <div className="w-full bg-gray-200 rounded-full h-2.5 overflow-hidden">
              <div
                className="bg-blue-600 h-2.5 rounded-full transition-all duration-200"
                style={{ width: `${progress}%` }}
              ></div>
            </div>
            <p className="text-xs font-medium text-gray-500 text-center mt-1.5">
              {progress}% {progress === 100 ? "• Processing on server..." : ""}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default UploadLoader;
